import Dexie from 'dexie'

export const db = new Dexie('fp')

db.version(1).stores({
  boards: 'id, insertOrder',
  briefs: 'id, insertOrder',
  folders: 'id, insertOrder',
  libraryAds: 'id, insertOrder',
  paginationKeys: 'id, insertOrder',
  spyderAnalytics: 'pageId, insertOrder',
  spyders: 'id, insertOrder',
  teamLibraryAds: 'id, insertOrder',
  uniqueCreatives: 'assetUrl, insertOrder'
})

db.version(2).stores({
  boards: 'id, insertOrder',
  briefs: 'id, insertOrder',
  folders: 'id, insertOrder',
  libraryAds: 'id, insertOrder',
  paginationKeys: 'id, insertOrder',
  spyderAnalytics: 'pageId, insertOrder',
  spyders: 'id, insertOrder',
  teamLibraryAds: 'id, insertOrder',
  uniqueCreatives: 'assetUrl, insertOrder',
  uniqueHooks: 'hookText'
})

// v3 adds spyderBrands, which caches subscriptions in the new Spyder API's shape. The legacy
// `spyders` table is left in place (and unread) so old cached records are never served to the
// new brands UI. It can be dropped once nothing reads the old shape.
db.version(3).stores({
  boards: 'id, insertOrder',
  briefs: 'id, insertOrder',
  folders: 'id, insertOrder',
  libraryAds: 'id, insertOrder',
  paginationKeys: 'id, insertOrder',
  spyderAnalytics: 'pageId, insertOrder',
  spyderBrands: 'id, insertOrder',
  spyders: 'id, insertOrder',
  teamLibraryAds: 'id, insertOrder',
  uniqueCreatives: 'assetUrl, insertOrder',
  uniqueHooks: 'hookText'
})

export default db;
